// MRS Studios — Cart drawer: fetch, render, update count, quantity, remove, discounts
(function () {
  'use strict';

  var itemsEl = document.getElementById('mrs-cart-items');
  var subtotalEl = document.getElementById('mrs-cart-subtotal');
  var countEl = document.getElementById('mrs-cart-count');
  var discountEl = document.getElementById('mrs-cart-discounts');

  function formatMoney(cents) {
    return '\u00a3 ' + (cents / 100).toFixed(2);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Display name = the first " | " segment; the rest of a Shopify title ("| Women Coat | MRS Studios")
  // is the marketplace SEO tail, as on the product cards and the product page.
  function shortTitle(t) {
    return String(t || '').split(' | ')[0];
  }

  // Line-item properties added with the item (e.g. "Pre-order: Dispatches in 2-4 weeks"). Keys that
  // start with "_" are hidden by Shopify convention.
  // ref: https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-add-js (properties)
  function propsHtml(props) {
    if (!props) return '';
    return Object.keys(props).filter(function (k) {
      return k.charAt(0) !== '_' && props[k] !== '' && props[k] != null;
    }).map(function (k) {
      return '    <p class="mrs-cart-item__prop">' + esc(k) + ': ' + esc(props[k]) + '</p>';
    }).join('');
  }

  function renderCart(cart) {
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="mrs-cart-empty">Your bag is empty.</p>';
      if (subtotalEl) subtotalEl.textContent = formatMoney(0);
      if (countEl) countEl.textContent = '0';
      if (discountEl) discountEl.innerHTML = '';
      return;
    }

    var html = cart.items.map(function (item) {
      var options = '';
      if (item.options_with_values && item.options_with_values.length > 0) {
        options = item.options_with_values.map(function (o) { return o.value; }).join(' / ');
      } else if (item.variant_title) {
        options = item.variant_title;
      }

      // Check for line-level discounts
      var discountHtml = '';
      var priceHtml = '';
      if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
        // Show original price struck through + discounted price
        priceHtml = '<span class="mrs-cart-item__price-original">' + formatMoney(item.original_line_price) + '</span> ';
        priceHtml += '<span class="mrs-cart-item__price-sale">' + formatMoney(item.final_line_price) + '</span>';
        // Show discount labels
        discountHtml = item.line_level_discount_allocations.map(function (d) {
          return '<span class="mrs-cart-item__discount">' + d.discount_application.title + ' (-' + formatMoney(d.amount) + ')</span>';
        }).join('');
      } else {
        priceHtml = '<span class="mrs-cart-item__price">' + formatMoney(item.final_line_price) + '</span>';
      }

      return [
        '<div class="mrs-cart-item" data-key="' + item.key + '">',
        '  <a href="' + item.url + '" class="mrs-cart-item__media">',
        '    <img src="' + item.image + '" alt="' + esc(shortTitle(item.product_title)) + '">',
        '  </a>',
        '  <div class="mrs-cart-item__details">',
        '    <a href="' + item.url + '" class="mrs-cart-item__title">' + esc(shortTitle(item.product_title)) + '</a>',
        options ? '    <p class="mrs-cart-item__variant">' + esc(options) + '</p>' : '',
        propsHtml(item.properties),
        '    <div class="mrs-cart-item__pricing">' + priceHtml + '</div>',
        discountHtml ? '    <div class="mrs-cart-item__discount-info">' + discountHtml + '</div>' : '',
        '    <div class="mrs-cart-item__actions">',
        '      <div class="mrs-cart-qty">',
        '        <button class="mrs-cart-qty__btn" data-action="minus" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Decrease quantity">&minus;</button>',
        '        <span class="mrs-cart-qty__val">' + item.quantity + '</span>',
        '        <button class="mrs-cart-qty__btn" data-action="plus" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>',
        '      </div>',
        '      <button class="mrs-cart-item__remove" data-key="' + item.key + '">Remove</button>',
        '    </div>',
        '  </div>',
        '</div>'
      ].join('');
    }).join('');

    itemsEl.innerHTML = html;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (countEl) countEl.textContent = cart.item_count;

    // Render cart-level discounts
    if (discountEl) {
      if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
        var dHtml = cart.cart_level_discount_applications.map(function (d) {
          return '<div class="mrs-cart-discount-line"><span>' + d.title + '</span><span>-' + formatMoney(d.total_allocated_amount) + '</span></div>';
        }).join('');
        // Show original total before cart-level discounts
        if (cart.original_total_price !== cart.total_price) {
          dHtml = '<div class="mrs-cart-discount-line mrs-cart-discount-line--original"><span>Subtotal</span><span class="mrs-cart-strikethrough">' + formatMoney(cart.original_total_price) + '</span></div>' + dHtml;
        }
        discountEl.innerHTML = dHtml;
      } else {
        discountEl.innerHTML = '';
      }
    }

    bindCartActions();
  }

  function bindCartActions() {
    // Remove buttons
    itemsEl.querySelectorAll('.mrs-cart-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeQuantity(btn.getAttribute('data-key'), 0);
      });
    });
    // Quantity buttons
    itemsEl.querySelectorAll('.mrs-cart-qty__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var qty = parseInt(btn.getAttribute('data-qty'), 10);
        var action = btn.getAttribute('data-action');
        var newQty = action === 'plus' ? qty + 1 : Math.max(0, qty - 1);
        changeQuantity(key, newQty);
      });
    });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function addToCart(variantId, quantity, properties) {
    var line = { id: variantId, quantity: quantity || 1 };
    if (properties) line.properties = properties;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(line)
    }).then(function (r) {
      return r.json().then(function (body) {
        // 422 (sold out / not enough stock): body.description is Shopify's customer-facing message.
        if (!r.ok) throw new Error(body.description || body.message || 'Could not add to bag.');
        return body;
      });
    });
  }

  function changeQuantity(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      // A refused change (e.g. more than in stock) returns an error body, not a cart: re-read the cart.
      .then(function (r) { return r.ok ? r.json() : fetchCart(); })
      .then(renderCart);
  }

  function applyDiscount(code) {
    // Shopify applies discount codes via URL redirect
    return fetch('/discount/' + encodeURIComponent(code))
      .then(function () { return fetchCart(); })
      .then(renderCart);
  }

  // Discount code form
  var discountForm = document.getElementById('mrs-discount-form');
  var discountInput = document.getElementById('mrs-discount-input');
  var discountMsg = document.getElementById('mrs-discount-msg');
  if (discountForm) {
    discountForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = discountInput.value.trim();
      if (!code) return;
      if (discountMsg) { discountMsg.textContent = 'Applying...'; discountMsg.className = 'mrs-discount-msg'; }
      applyDiscount(code).then(function () {
        discountInput.value = '';
        if (discountMsg) { discountMsg.textContent = 'Code applied!'; discountMsg.className = 'mrs-discount-msg mrs-discount-msg--ok'; }
        setTimeout(function () { if (discountMsg) discountMsg.textContent = ''; }, 3000);
      });
    });
  }

  window.MrsCart = {
    render: function () {
      fetchCart().then(renderCart);
    },
    // Returns a promise; it rejects with Shopify's message when the item cannot be added.
    add: function (variantId, quantity, properties) {
      return addToCart(variantId, quantity, properties)
        .then(function () { return fetchCart(); })
        .then(function (cart) {
          renderCart(cart);
          window.MrsHeader && window.MrsHeader.openCart();
          return cart;
        });
    }
  };

  // Cart item styles
  var style = document.createElement('style');
  style.textContent = [
    '.mrs-cart-empty{color:var(--text-secondary);font-family:var(--font-sans);font-size:12px;padding:20px 0;}',

    '.mrs-cart-item{display:grid;grid-template-columns:80px 1fr;gap:14px;margin-bottom:20px;padding-bottom:20px;border-bottom:1px solid var(--border-light);}',
    '.mrs-cart-item:last-child{border-bottom:none;}',

    '.mrs-cart-item__media{display:block;aspect-ratio:2/3;overflow:hidden;background:var(--bg-card);}',
    '.mrs-cart-item__media img{width:100%;height:100%;object-fit:cover;}',

    '.mrs-cart-item__details{display:flex;flex-direction:column;min-width:0;}',
    '.mrs-cart-item__title{font-family:var(--font-sans);font-size:12px;font-weight:400;color:var(--text-primary);margin-bottom:4px;line-height:1.4;text-decoration:none;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}',
    '.mrs-cart-item__variant{font-family:var(--font-sans);font-size:11px;color:var(--text-secondary);margin-bottom:4px;}',
    '.mrs-cart-item__prop{font-family:var(--font-sans);font-size:10px;letter-spacing:0.04em;color:var(--text-primary);margin-bottom:4px;}',

    '.mrs-cart-item__pricing{margin-bottom:4px;}',
    '.mrs-cart-item__price{font-family:var(--font-sans);font-size:12px;color:var(--text-secondary);font-weight:300;}',
    '.mrs-cart-item__price-original{font-family:var(--font-sans);font-size:11px;color:var(--text-secondary);font-weight:300;text-decoration:line-through;}',
    '.mrs-cart-item__price-sale{font-family:var(--font-sans);font-size:12px;color:#9b2c2c;font-weight:400;}',

    '.mrs-cart-item__discount-info{margin-bottom:4px;}',
    '.mrs-cart-item__discount{display:inline-block;font-family:var(--font-sans);font-size:9px;letter-spacing:0.05em;color:#9b2c2c;background:rgba(155,44,44,0.06);padding:2px 6px;border-radius:2px;margin-right:4px;}',

    '.mrs-cart-item__actions{display:flex;align-items:center;justify-content:space-between;margin-top:auto;}',

    '.mrs-cart-qty{display:flex;align-items:center;border:1px solid var(--border-light);}',
    '.mrs-cart-qty__btn{font-family:var(--font-sans);font-size:14px;width:30px;height:30px;display:flex;align-items:center;justify-content:center;background:none;border:none;color:var(--text-secondary);cursor:pointer;transition:color 0.2s ease;}',
    '.mrs-cart-qty__btn:hover{color:var(--text-primary);}',
    '.mrs-cart-qty__val{font-family:var(--font-sans);font-size:11px;min-width:24px;text-align:center;color:var(--text-primary);}',

    '.mrs-cart-item__remove{font-family:var(--font-sans);font-size:10px;letter-spacing:0.1em;text-transform:uppercase;color:var(--text-secondary);background:none;border:none;cursor:pointer;padding:4px 0;transition:color 0.2s ease;text-decoration:underline;text-underline-offset:2px;}',
    '.mrs-cart-item__remove:hover{color:var(--text-primary);}',

    /* Cart-level discounts */
    '.mrs-cart-discount-line{display:flex;justify-content:space-between;font-family:var(--font-sans);font-size:11px;color:#9b2c2c;margin-bottom:6px;}',
    '.mrs-cart-discount-line--original{color:var(--text-secondary);}',
    '.mrs-cart-strikethrough{text-decoration:line-through;}',

    /* Discount code form */
    '.mrs-discount-form{display:flex;gap:8px;margin-bottom:12px;}',
    '.mrs-discount-input{flex:1;font-family:var(--font-sans);font-size:11px;letter-spacing:0.05em;text-transform:uppercase;padding:8px 12px;border:1px solid var(--border-light);background:transparent;color:var(--text-primary);outline:none;}',
    '.mrs-discount-input::placeholder{color:var(--text-secondary);text-transform:uppercase;}',
    '.mrs-discount-input:focus{border-color:var(--text-primary);}',
    '.mrs-discount-btn{font-family:var(--font-sans);font-size:10px;letter-spacing:0.12em;text-transform:uppercase;padding:8px 16px;background:var(--text-primary);color:var(--bg-primary);border:none;cursor:pointer;transition:opacity 0.2s ease;}',
    '.mrs-discount-btn:hover{opacity:0.8;}',
    '.mrs-discount-msg{font-family:var(--font-sans);font-size:10px;color:var(--text-secondary);margin-bottom:8px;}',
    '.mrs-discount-msg--ok{color:#2d6a4f;}'
  ].join('');
  document.head.appendChild(style);
})();
